import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'environments/environment';
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.indexOf(environment.apiBaseUrl) != -1 &&
      request.url.indexOf(`auth/sso-login`) == -1 &&
      !request.headers.has("Authorization")
    ) {
      if (this._authService.token && this._authService.tokenExpired) {
        if (
          request.url.indexOf("auth/refresh") == -1 &&
          request.url.indexOf("auth/login") == -1
        ) {
          return this._authService.refreshAuthToken().pipe(
            switchMap((x) => {
              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${this._authService.token}`,
                },
              });
              return next.handle(request);
            })
          );
        } else {
          return next.handle(request);
        }
      } else {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this._authService.token}`,
          },
        });

        return next.handle(request);
      }
      if (this._authService.token) {
        //normal login
      } else {
        //sso login
        // let ssoToken = "";
        // const account =
        //     this.msalAuthService.instance.getAllAccounts()[0];
        // const accessTokenRequest = {
        //     scopes: [
        //         "api://7b39cb43-16c1-49bd-881e-3f2e0b2d72a2/access-eforms",
        //     ],
        //     account: account,
        // };
        // return from(
        //     this.msalAuthService.instance.acquireTokenSilent(
        //         accessTokenRequest
        //     )
        // ).pipe(
        //     switchMap((accessTokenResponse) => {
        //         // Acquire token silent success
        //         ssoToken = accessTokenResponse.accessToken;
        //         request = request.clone({
        //             setHeaders: {
        //                 Authorization: `Bearer ${ssoToken}`,
        //             },
        //         });
        //         return next.handle(request);
        //     }),
        //     catchError((error) => {
        //         if (error instanceof InteractionRequiredAuthError) {
        //             return from(
        //                 this.msalAuthService.instance.acquireTokenPopup(
        //                     accessTokenRequest
        //                 )
        //             ).pipe(
        //                 switchMap((accessTokenResponse) => {
        //                     // Acquire token interactive success
        //                     ssoToken = accessTokenResponse.accessToken;
        //                     request = request.clone({
        //                         setHeaders: {
        //                             Authorization: `Bearer ${ssoToken}`,
        //                         },
        //                     });
        //                     return next.handle(request);
        //                 }),
        //                 catchError((error) => {
        //                     // Acquire token interactive failure
        //                     console.log(error);
        //                     return next.handle(request);
        //                 })
        //             );
        //         } else {
        //             console.log(error);
        //             return next.handle(request);
        //         }
        //     })
        // );
      }
    } else {
      return next.handle(request);
    }
  }
}
